import { useQuery } from '@tanstack/react-query';
import { cashFlowService } from '../services/apiServices';

export const useCashFlowProjection = (params?: { procurement_id?: number }) => {
  return useQuery({
    queryKey: ['cash-flow', 'projection', params],
    queryFn: () => cashFlowService.getProjection(params),
  });
};
